import {Curve} from '../Models/Curve';

export function averageCurve(curves: Curve[]): Curve {
    if (curves.length === 0) {
        return [];
    }

    // Find the reference curve with the most X coordinates
    const referenceCurve = curves.reduce((curve, currentCurve) => {
        return currentCurve.length > curve.length ? currentCurve : curve;
    }, curves[0]);

    // Initialize an array to store summed Y values, with the same X values as the reference curve
    const summedCurve = referenceCurve.map((point) => ({x: point.x, y: 0}));

    // Sum the Y values from all curves
    for (const curve of curves) {
        for (let i = 0; i < curve.length; i++) {
            if (i < summedCurve.length) {
                summedCurve[i].y += curve[i].y;
            }
        }
    }

    // Compute the average Y values
    return summedCurve.map((point) => ({
        x: point.x,
        y: point.y / curves.length,
    }));
}
